import React, { useState } from 'react';
import { Form, Button, Card, Alert, Container } from 'react-bootstrap';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import nec_logo from './nec_logo.jpeg';

const Login: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [employeeCode, setEmployeeCode] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(employeeCode, password);
      navigate('/');
    } catch (err) {
      setError('Invalid credentials');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #e0f7fa 0%, #e0ffe0 100%)' }}>
      <Container className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Card className="shadow-lg p-4" style={{ minWidth: 350, maxWidth: 400 }}>
          <Card.Body>
            <div className="text-center mb-4">
              <img src={nec_logo} alt="Logo" width={56} height={56} />
              <h3 className="mt-2 mb-0" style={{ color: '#156082' }}>LDB Project Attendance System</h3>
            </div>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="employeeCode">
                <Form.Label>Employee Code</Form.Label>
                <Form.Control type="text" value={employeeCode} onChange={e => setEmployeeCode(e.target.value)} required autoFocus autoComplete="username" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
              </Form.Group>
              {error && <Alert variant="danger">{error}</Alert>}
              <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Login; 